// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","divider":"menuDivider_divider__vul6E"};